<template>
  <ToggleSection label="Control Sample" :collapsed="!dv.isEditing">
    <FieldGrid
      class="form-fields"
      :fields="[['control_name', 'control_type']]"
      :dv="dv"
      :validation-errors="validationErrors"
    />
  </ToggleSection>
</template>

<script>
import ToggleSection from '@/components/fields/ToggleSection.vue'
import FieldGrid from '@/components/fields/FieldGrid.vue'

export default {
  name: 'ControlSample',
  components: { ToggleSection, FieldGrid },
  props: {
    dv: { type: Object, required: true },
    validationErrors: { type: Object, default: () => ({}) },
  },
}
</script>
